import { Injectable } from '@tanbo/vue-di-plugin'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'
import { Subject } from 'rxjs'
import { UserecordList } from '../../service'
import { getSoftGroupCatalogListSync } from '@/utils/soft-group-catalog'

export enum RankType {
  duration = 1,
  useSoftCount = 2,
  terminalCount = 3
}

export const rankCardTitleI18nKey: Record<RankType, string> = {
  [RankType.duration]: 'softwareUsage.rankSoftDurationDist',
  [RankType.useSoftCount]: 'softwareUsage.rankSoftUseCountDist',
  [RankType.terminalCount]: 'softwareUsage.rankSoftTerminalCountDist'
}

/** 软件视图排行饼图 series.name */
export const rankCardSeriesNameI18nKey: Record<RankType, string> = {
  [RankType.duration]: 'softwareUsage.rankSeriesSoftDuration',
  [RankType.useSoftCount]: 'softwareUsage.rankSeriesSoftUseCount',
  [RankType.terminalCount]: 'softwareUsage.rankSeriesSoftTerminalCount'
}

export interface SoftwareUsageReq {
  end_time?: string
  limit?: number
  page?: number
  soft_group_id?: number
  soft_name?: string
  start_time?: string
  /** 排序字段 */
  sort?: string
  /** 顺序 */
  asc?: boolean
  device_id?: string
  /** 仅闲置：传 1（与 `UserecordRequestParams.idle_only` 一致） */
  idle_only?: number
}

/** 与 `POST /softmgr/userecord/soft-list` 行数据一致（见 `UserecordList`） */
export type SoftwareUsageData = UserecordList

export interface SoftGroup {
  group_id: number
  group_name: string
  group_desc: string
}

export type SoftwareUsageListTableRow = UserecordList

@Injectable()
export class SoftwareViewService {
  updateEvent = new Subject()

  constructor (private http: Http) {
  }
  @ParamsClean([0], 1)
  download (type: 0|1, options: SoftwareUsageReq, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/userecord/soft-export', params, moduleName)
  }

  softGroup () {
    return Promise.resolve({ list: getSoftGroupCatalogListSync() })
  }
}
